import { render, staticRenderFns } from "./WelcomeExplanationPage.vue?vue&type=template&id=2892c582&scoped=true&"
import script from "./WelcomeExplanationPage.vue?vue&type=script&lang=js&"
export * from "./WelcomeExplanationPage.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeExplanationPage.vue?vue&type=style&index=0&id=2892c582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2892c582",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2892c582')) {
      api.createRecord('2892c582', component.options)
    } else {
      api.reload('2892c582', component.options)
    }
    module.hot.accept("./WelcomeExplanationPage.vue?vue&type=template&id=2892c582&scoped=true&", function () {
      api.rerender('2892c582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Other/WelcomeExplanationPage.vue"
export default component.exports